import image1o from '../assets/images/hero/1280x720/1.png'
import image1 from '../assets/images/hero/raw/portrait3.jpg'
import image1L from '../assets/images/hero/raw/landscape1.jpg'
import image2 from '../assets/images/hero/1280x720/2.png'
import image2L from '../assets/images/hero/1280x720/2.png'
import image3 from '../assets/images/hero/1280x720/3.png'
import image3L from '../assets/images/hero/1280x720/3.png'
import image4 from '../assets/images/hero/1280x720/4.png'
import image4L from '../assets/images/hero/1280x720/4.png'
import image5 from '../assets/images/hero/1280x720/5.png'
import image5L from '../assets/images/hero/1280x720/5.png'
import image6 from '../assets/images/hero/1280x720/6.png'
import image6L from '../assets/images/hero/1280x720/6.png'

const products = [
  {
    id: 1,
    srcHeroPortrait: image1,
    srcHeroLandscape: image1L,
    srcLatest: image1o,
    alt: 'organik tanpa msg - Tepung Bumbu Qreezpy',
    heading: 'Tepung Bumbu Serbaguna',
    subheading: 'Tanpa MSG dan tanpa bahan pengawet'
  },
  {
    id: 2,
    srcHeroPortrait: image2,
    srcHeroLandscape: image2L,
    srcLatest: image2,
    alt: 'organik tanpa msg - Kaldu Ayam',
    heading: 'Kaldu Ayam',
    subheading: 'Diproses dari ayam asli tanpa MSG dan bahan pengawet'
  },
  {
    id: 3,
    srcHeroPortrait: image3,
    srcHeroLandscape: image3L,
    srcLatest: image3,
    alt: 'organik tanpa msg - Bumbu Instan Rempah -Abon',
    heading: 'Bumbu Instan Rempah',
    subheading: 'Dengan bahan alami dan tanpa pengawet'
  },
  {
    id: 4,
    srcHeroPortrait: image4,
    srcHeroLandscape: image4L,
    srcLatest: image4,
    alt: 'organik tanpa msg - Abon 100% Daging Asli',
    heading: 'Abon 100% Daging Asli',
    subheading: 'Terbuat dari daging asli tanpa MSG dan bahan pengawet'
  },
  {
    id: 5,
    srcHeroPortrait: image5,
    srcHeroLandscape: image5L,
    srcLatest: image5,
    alt: 'organik tanpa msg - Beras Organik',
    heading: 'Beras Organik',
    subheading: 'Alami dan sehat, tidak menggunakan pestisida'
  },
  {
    id: 6,
    srcHeroPortrait: image6,
    srcHeroLandscape: image6L,
    srcLatest: image6,
    alt: 'organik tanpa msg - Bubur Organik',
    heading: 'Bubur Organik',
    subheading: '100% tanpa bahan pengawet'
  }
]

export default products